import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/qa-operations-core/design-date/')({});